<template>
    <v-container fluid>
        <v-row dense>
            <v-col class="pa-0" md="6" sm="12"> <JoiningSeafarersTable /> </v-col>
            <v-col class="pa-0" md="6" sm="12"> <DocumentsNearExpirationTable /> </v-col>
            <v-col class="pa-0" md="6" sm="12"><PlannedSeafarersTable /> </v-col>
            <v-col class="pa-0" md="6" sm="12"> <ContractsNearExpirationTable /> </v-col>
            <v-col class="pa-0" md="12" sm="12"> <LatestApplicationsTable /></v-col>
        </v-row>
    </v-container>
</template>

<script>
import JoiningSeafarersTable from './JoiningSeafarersTable.vue';
import DocumentsNearExpirationTable from './DocumentsNearExpirationTable.vue';
import PlannedSeafarersTable from './PlannedSeafarersTable.vue';
import ContractsNearExpirationTable from './ContractsNearExpirationTable.vue';
import LatestApplicationsTable from './LatestApplicationsTable.vue';
export default {
    name: 'Dashboard',
    components: {
        JoiningSeafarersTable,
        DocumentsNearExpirationTable,
        PlannedSeafarersTable,
        ContractsNearExpirationTable,
        LatestApplicationsTable,
    },
    data() {
        return {};
    },
    watch: {},
    computed: {},
    methods: {},
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        this.$myStore.commit('setBreadcrumbs', []);
    },
};
</script>

<style scoped></style>
